import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Greetings = () => {
  const [imageSrc, setImageSrc] = useState('');
  const [greetingText, setGreetingText] = useState('');
  const [greet, setGreet] = useState(true);
  const location = useLocation();


  const morningImage = "/images/morning.png";
  const afternoonImage = "/images/afternoon.png";
  const eveningImage = "/images/night.png";

  function getLastSegment(url) {
    const segments = url.split('/').filter(Boolean);
    return segments.length > 0 ? segments[segments.length - 1] : '';
  }

  const path = getLastSegment(location.pathname);

  useEffect(() => {
    setGreet(prevGreet => {
      const newGreet = path !== 'home';
      return prevGreet !== newGreet ? newGreet : prevGreet;
    });
  }, [path]);


  useEffect(() => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();

    if (currentHour < 12) {
      setGreetingText('Morning');
      setImageSrc(morningImage);
    } else if (currentHour >= 12 && currentHour < 17) {
      setGreetingText('Afternoon');
      setImageSrc(afternoonImage);
    } else {
      setGreetingText('Evening');
      setImageSrc(eveningImage);
    }
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 2, md: 3 },
        padding: { xs: 2, sm: 3, md: 4 },
        minHeight: { xs: 'auto', md: '300px' },
        width: '100%',
      }}
    >
      {/* Greeting Text Section */}
      {greet && (
        <Box
          sx={{
            flex: { xs: '1', md: '0 0 50%' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            pl: { md: 2 },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '32px', md: '48px' },
              lineHeight: 1.1,
              mb: 1,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Good {greetingText}!
          </Typography>
          <Typography variant="h6" fontWeight={400} color="text.secondary">
            Let's do great things together 🚀
          </Typography>
        </Box>
      )}

      {/* Greeting Image Section */}
      <Box
        sx={{
          flex: { xs: '1', md: '1' },
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          sx={{
            width: '100%',
            maxWidth: '450px',
            borderRadius: '24px',
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.1))',
            transition: 'transform 0.4s ease',
            '&:hover': {
              transform: 'scale(1.02) rotate(1deg)',
            },
          }}
        />
      </Box>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes fadeInUp {
            from { 
              opacity: 0; 
              transform: translateY(20px);
            }
            to { 
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeInRight {
            from { 
              opacity: 0; 
              transform: translateX(30px);
            }
            to { 
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes slideIn {
            from { 
              transform: translateX(-20px); 
              opacity: 0; 
            }
            to { 
              transform: translateX(0); 
              opacity: 1; 
            }
          }
          
          @keyframes float {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            33% { transform: translate(30px, -30px) rotate(120deg); }
            66% { transform: translate(-20px, 20px) rotate(240deg); }
          }
          
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          
          @keyframes wave {
            0%, 100% { transform: rotate(0deg); }
            25% { transform: rotate(-15deg); }
            75% { transform: rotate(15deg); }
          }
          
          @keyframes twinkle {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(1.2); }
          }
          
          @keyframes textShine {
            0%, 100% { filter: brightness(1); }
            50% { filter: brightness(1.2); }
          }
        `}
      </style>
    </Box>
  );
};

export default Greetings;